import React from 'react'
import {
  Grid,
  Typography,
} from '@material-ui/core'

import { GenericCard } from '../ModelCard'
import {
  AssignmentHandler
} from '../../scanRouter/handlers'

interface AssignmentDisplayProps {
  handler: AssignmentHandler
}

export const AssignmentDisplay = (props: AssignmentDisplayProps) => {
  const { handler } = props
  if (!handler.obj?.object || !handler.assignment?.object) {
    return null
  }
  return (
    <Grid container justify="center">
      <Grid item xs={12}>
        <Typography>
          Assigning...
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <GenericCard item={handler.obj} />
      </Grid>
      <Grid item xs={12}>
        <Typography>
          To...
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <GenericCard item={handler.assignment} />
      </Grid>
      <Grid item xs={12}>
        <Typography>
          Scan again to confirm!
        </Typography>
      </Grid>
    </Grid>
  )
}

